import React, { Component } from 'react';

export default class MediaVideo extends Component {
  render() {
    const { url, type, poster } = this.props;
    const className = (["child-video__container"].concat([type])).join(" ");

    if (!url) {
      return null;
    }

    return (
      <video playsInline muted={false} controls preload="auto">
        <source src={url} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    );
  }
}